import { render } from "./InventoryValueReport.vue?vue&type=template&id=c6cef3c6&scoped=true"
import script from "./InventoryValueReport.vue?vue&type=script&lang=js"
export * from "./InventoryValueReport.vue?vue&type=script&lang=js"

import "./InventoryValueReport.vue?vue&type=style&index=0&id=c6cef3c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6cef3c6"]])

export default __exports__